import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { reopenChat } from '../../../services/chats';

interface IProps {
  chatId: number;
}
export const ThunkReopenChat = createAsyncThunk<boolean, IProps>(
  `${storeResources.CHATS}/reopenChat`,
  ({ chatId }) => reopenChat(chatId).then(res => res.data),
);
